import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './style';
export default function Message(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === void 0 ? {} : _ref$message,
      type = _ref.type;
  if (message.text) return React.createElement(Container, {
    type: type,
    style: {
      marginTop: 10
    }
  }, React.createElement("div", {
    key: message.type + message.text
  }, message.text));
  return '';
}
Message.propTypes = {
  message: PropTypes.object
};